<div class="logistics-dialog-header">
  <mat-toolbar id="dialog-titlebar" color="primary">
    <div>Create/Edit Logistics</div>
  </mat-toolbar>
</div>
<form [formGroup]="logisticForm" class="logistics-form" (submit)="onSubmit(logisticForm)">
  <div mat-dialog-content class="logistics-dialog-content">
    <mat-form-field appearance="outline" class="logistics-form-field">
      <mat-label>Name*</mat-label>
      <input id="logistic-name" type="text" matInput data-testid="lp-logistics-name-input" aria-describedby="logistic-name-required" formControlName="name" />
      <mat-error id="logistic-name-required" *ngIf="logisticForm.controls.name.errors?.required">
        This field is mandatory.
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="logistics-form-field" subscriptSizing="dynamic">
      <mat-label>Value</mat-label>
      <input id="logistic-value" type="text" matInput data-testid="lp-logistics-value-input" formControlName="value" />
    </mat-form-field>
  </div>
  <div mat-dialog-actions class="logistics-dialog-actions">
    <button mat-raised-button color="warn" type="button" data-testid="lp-logistics-cancel-button" (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" type="submit" data-testid="lp-logistics-ok-button" [disabled]="logisticForm.invalid">Ok</button>
  </div>
</form>
